export default __webpack_public_path__ + "static/media/sin-gluten.1c5e157b.png";